// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//urls should be in the format of [protocol]://[fqdn]{:port}{/common path}
//example:
//if the documents API exists at https://eqms-documents.azurewebsites.net/api/documents
//then here the entry would look like: https://eqms-documents.azurewebsites.net/api/

//this is non-standard, the environment name is prod-p002-dewc, but due to issues with multiple environments in the same subscription and region, had to split the name into the suffix

//let environmentName = "dev-green";
let prefix = "https://";
let suffix = ".prod-p087.eqms.ww.eurofinsbpt.com/api/";
//let environmentName = "";
//let prefix = "https://";
//let suffix = ".eqms.eu.eurofinsbpt.com/api/";

let documentsApi = prefix + "documents" + suffix;
let delegatesApi = prefix + "delegates" + suffix;
let assignmentGroupsApi = prefix + "assignment-groups" + suffix;
let trainingApi = prefix + "training" + suffix;
let administrationApi = prefix + "administration" + suffix;
let changeManagement = prefix + "changemanagement" + suffix;
let recordKPRApi = prefix  + "recordkpr"  + suffix;
let skillsApi = prefix + "skill" + suffix;

//let documentsApi = prefix + "documents." + environmentName + suffix;
//let delegatesApi = prefix + "delegates." + environmentName + suffix;
//let assignmentGroupsApi = prefix + "assignment-groups." + environmentName + suffix;
//let trainingApi = prefix + "training." + environmentName + suffix;
//let administrationApi = prefix + "administration." + environmentName + suffix;
//let changeControlApi = prefix + "changemanagement." + environmentName + suffix;

export const environment = {
  production: true,
  urls: {
    apis: {
      documents: documentsApi,
      documentAttachments: documentsApi,
      changeRequests: documentsApi,
      hardCopyActivities: documentsApi,
      dependencies: "https://identity.eqms.ww.eurofinsbpt.com/Carbon/api/",
      files: "https://files.prod-p087.eqms.ww.eurofinsbpt.com/api/",
      delegates: delegatesApi,
      assignmentgroups: assignmentGroupsApi,
      courses: trainingApi,
      boron: "https://app-eqms-elims-boron-p087-dewc.azurewebsites.net/",
      administration: administrationApi,
      changeControl: changeManagement,
      recordKPR: recordKPRApi,
      skills: skillsApi
    }
  },
  surveyJsProductKey:"ZDBlYWZjYmMtYTg2Mi00M2ZlLTg4MWUtMWJkMmMwY2ViNjI0OzE9MjAyNC0xMC0xMCwyPTIwMjMtMDItMDc=",
  retryAttempts:1
};  